function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  id: "Dropdown"
}, /*#__PURE__*/React.createElement("path", {
  id: "Dropdown_2",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.5499 6.26324C10.245 5.91225 9.75501 5.91225 9.45013 6.26324L3.22808 13.4629C2.92397 13.8157 2.92397 14.3844 3.22808 14.7354C3.53218 15.0882 4.0245 15.0882 4.32782 14.7354L10 8.17294L15.6722 14.7354C15.9763 15.0882 16.4686 15.0882 16.7719 14.7354C17.076 14.3844 17.076 13.8157 16.7719 13.4629L10.5499 6.26324Z",
  fill: "#4A4A4A",
  stroke: "#4A4A4A"
}));

function SvgCollapse({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollapse);
export default __webpack_public_path__ + "static/media/collapse.c5b73a6312eec16bf68099b24446c199.svg";
export { ForwardRef as ReactComponent };